module.exports = __webpack_public_path__ + "img/SES_180412260.33dc47dc.jpg";